.input {
  width: 80px;

  input {
    width: 100%;
  }
}
